/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map 



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/node_modules/rxjs/_esm5/util/isFunction.js
// module id = ../../../../rxjs/_esm5/util/isFunction.js
// module chunks = vendor